// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AxQa","label":"styles_label__3Qg0Q"};